/**
 * Manche d’ouverture (1er tour de table : tant qu’un pilote a 0 lancer).
 * Spec §6 : pas de duel ; cases pleines traversables ; interdiction de
 * terminer sur une case déjà à 2 occupants. Après ce tour, duels normaux.
 */
export function isOpeningRoundNoOvertake(
  playerTotalDiceRolls: readonly number[],
  numPlayers?: number
): boolean {
  const n = numPlayers ?? playerTotalDiceRolls.length;
  for (let i = 0; i < n; i++) {
    if ((playerTotalDiceRolls[i] ?? 0) === 0) return true;
  }
  return false;
}
